import {TabsProps} from "antd";
import {HistoryExamine, Tabs} from "components/common";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import ListPatient from "./ListPatient/ListPatient";
import DetailPatient from "./Detail/Detail";
import ExaminationCard from "./ExaminationCard/ExaminationCard";
import {setSiderKey} from "redux/reducer/common";
import ApoitmentPatient from "pages/Customer/CustomerCare/components/CustomerList/ChildTabs/Apoitment";
import ReportTV from "./Report/ReportTV";

const ConsultantAndTreatment: React.FC = () => {
  const activeTab = useAppSelector(e => e.common.activeTab);
  const dispatch = useAppDispatch();
  const id = useAppSelector(
    e => e.consultantAndFragment.idConsultantAndFragment
  );
  document.title = "Tư vấn điều trị";
  useEffect(() => {
    dispatch(setSiderKey("tuVanDieuTri"));
  }, []);

  const items: TabsProps["items"] = [
    {
      key: tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT,
      label: "BN chờ tư vấn",
      children: <ListPatient />,
    },
    // {
    //   key: tabKeys.CONSULTANT_AND_FRAGMENT
    //     .LIST_CONSULTANT_AND_FRAGMENT_RECEIVED,
    //   label: "BN đã tiếp nhận",
    //   children: <ListPatientReceived />,
    // },
    {
      key: tabKeys.CONSULTANT_AND_FRAGMENT.APPOITMENT,
      label: `BN có lịch PT `,
      children: <ApoitmentPatient />,
    },
    {
      key: tabKeys.CONSULTANT_AND_FRAGMENT.DETAIL_CONSULTANT_AND_FRAGMENT,
      label: "Chi tiết thông tin",
      children: <DetailPatient />,
      disabled: id ? false : true,
    },
    {
      key: tabKeys.CONSULTANT_AND_FRAGMENT.HISTORY_EXAMINE,
      label: "Lịch sử khám bệnh",
      children: (
        <HistoryExamine
          tabName={tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT}
        />
      ),
      disabled: id ? false : true,
    },
    // {
    //   key: tabKeys.CONSULTANT_AND_FRAGMENT.EXAMINATION_CARD,
    //   label: "Thẻ khám bệnh",
    //   children: <ExaminationCard />,
    //   disabled: id ? false : true, ReportTV
    // },
    {
      key: tabKeys.CONSULTANT_AND_FRAGMENT.REPORT,
      label: "DS bệnh nhân đã phẫu thuật",
      children: <ReportTV />,
    },
  ];
  return (
    <div className="consultan page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default ConsultantAndTreatment;
